import React, { useState, MouseEvent } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from '@printdeal/ui-library';
import { SanitizedOrder } from '../../../../../../types/order/Order';
import ChangePaymentMethodModal from './ChangePaymentMethodModal';
import useChangePaymentMethod from './useChangePaymentMethod';
import { dispatchAccountEvent } from '../../../../../../helpers/dataLayerHelpers/accountDataLayerHelper';

interface ChangePaymentMethodButtonProps {
  order: SanitizedOrder,
}

const ChangePaymentMethodButton = ({ order }: ChangePaymentMethodButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isPaymentMethodChangeable = useChangePaymentMethod(order);

  if (!isPaymentMethodChangeable.enabled) {
    return null;
  }

  const handleOpenModal = (event: MouseEvent) => {
    event.preventDefault();
    setIsModalOpen(true);
    dispatchAccountEvent('order_detail_interaction', 'open_modal_download_files');
  };

  const handleCloseModal = (eventName: string) => {
    setIsModalOpen(false);
    dispatchAccountEvent('order_detail_interaction', eventName);
  };

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <Link
        variant="secondary"
        as="button"
        onClick={handleOpenModal}
        className="pd-text-xs"
        iconBefore="edit"
        data-cy="changePaymentButton"
      >
        <FormattedMessage
          id="account.details.button.change.paymentmethod"
          defaultMessage="Change payment method"
        />
      </Link>
      {
        isModalOpen && (
          <ChangePaymentMethodModal
            order={order}
            handleCloseModal={handleCloseModal}
          />
        )
      }
    </>
  );
};

export default ChangePaymentMethodButton;
